import axios from 'axios';

export class APIService {

  constructor() {
    this.api = 'http://142.93.155.152:8080/api';
    //this.api = 'http://192.168.0.112:8080/api'
    //this.api = 'http://localhost:8080/api';
  }

   setToken(token) {
    this.token = token;
    axios.defaults.headers.common['Authorization'] = token;
  }

  login(email, pass) {
    var headers = {
      "email": email,
      "pass": pass
    }
    const url = this.api + '/auth/login';
    return axios.post(url, null, {
      "headers": headers
    });
  }

  register(fname, lname, username, email, pass, city, address) {
    var data = {
      'email': email,
      'fname': fname,
      'lname': lname,
      'username': username,
      'password': pass,
      'city': city,
      'address': address
    }

    const url = this.api + '/auth/register';
    return axios.post(url, data)
  }

  verifyToken(token){
    var params = {
      "token":token
    }
    const url = this.api + '/auth/verify';
    return axios.get(url,{params});
  }

  getProgs() {
    const url = this.api + '/programmers/all';
    return axios.get(url);
  }

  addProg(prog) {
    let data = {
      'prog':prog
    }
    const url = this.api + '/programmers/update';
    return axios.post(url,data);
  }

  deleteProg(prog){
    let data = {
      'prog':prog
    }
    const url = this.api + '/programmers/delete';
    return axios.post(url,data);
  }

  getLocations(){
    const url = this.api + '/locations/all';
    return axios.get(url);
  }

  updateLocation(location){
    const url = this.api + '/locations/update';
    return axios.post(url,location);
  }

  addLocation(location){
    const url = this.api + '/locations/insert';
    return axios.post(url,location);
  }

  deleteLocation(id){
    const url = this.api + '/locations/delete';
    const params = {
      "id": id
    }
    return axios.delete(url,{params});
  }


  getSuppliers(){
    const url = this.api + '/suppliers/all';
    return axios.get(url);
  }

  addSupplier(location){
    const url = this.api + '/suppliers/update';
    return axios.post(url,location);
  }

  deleteSupplier(location){
    const url = this.api + '/suppliers/delete';
    return axios.post(url,location);
  }

  getRoles(){
    const url = this.api + '/roles/all';
    return axios.get(url);
  }

  getUsers(){
    const url = this.api + '/users/all';
    return axios.get(url);
  }

  updateUser(user){
    const url = this.api + '/users/update';
    return axios.post(url,user);
  }

  getSystemTypes(){
    const url = this.api + '/systemtypes/all';
    return axios.get(url);
  }

  getKeyTypes(){
    const url = this.api + '/keytypes/all';
    return axios.get(url);
  }

  getTransponders(){
    const url = this.api + '/transponders/all';
    return axios.get(url);
  }

  getManufacturers(){
    const url = this.api + '/manufacturers/all';
    return axios.get(url);
  }

  getButtons(){
    const url = this.api + '/buttons/all';
    return axios.get(url);
  }

  saveVehicle(vehicle){
    const url = this.api + '/vehicles/save';
    return axios.post(url,vehicle);
  }

  getMakes(){
    const url = this.api + '/vehicles/makes';
    return axios.get(url);
  }

  getModels(make){
   var params = {
     "make":make
   }
   const url = this.api + '/vehicles/models';
   return axios.get(url,{params});
  }

  getYears(make,model){
   var params = {
     "make":make,
     "model":model
   }
   const url = this.api + '/vehicles/years';
   return axios.get(url,{params});
  }

  saveKey(key,file){
    let form = new FormData();

    if(file != null)
      form.append("file",file);

    form.append("key",JSON.stringify(key))

    const url = this.api + '/keys/save';

    return axios.post(url,form,{
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  searchKey(query){
   var params = {
     "query":query
   }
   const url = this.api + '/keys/search';
   return axios.get(url,{params});
  }

  deleteKey(key){
    const url = this.api + '/keys/delete';
    return axios.post(url,key);
  }

  searchVehicle(make,model,year){
    var params = {
      "make":make,
      "model":model,
      "year":year
    }
    const url = this.api + '/vehicles/search';
    return axios.get(url,{params});
  }

  deleteVehicle(vehicle){
    const url = this.api + '/vehicles/delete';
    return axios.post(url,vehicle);
  }

  searchItem(request){
    const url = this.api + '/items/search';
    return axios.post(url,request);
  }

  getItem(oem){
    var params = {
      "oem":oem
    }
    const url = this.api + '/items/checkStock';
    return axios.get(url,{params});
  }

  recieveItem(request){
    const url = this.api + '/items/recieve';
    return axios.post(url,request);
  }

  moveItems(request){
    const url = this.api + '/items/move';
    return axios.post(url,request);
  }

  adjustItem(request){
    const url = this.api + '/items/adjust';
    return axios.post(url,request);
  }

  getStock(oem,id){
    var params = {
      "oem":oem,
      "id":id,
    }
    const url = this.api + '/items/checkStock';
    return axios.get(url,{params});
  }

  getItemHistory(page){
    var params = {
      "page":page
    }
    const url = this.api + '/items/history/latest';
    return axios.get(url,{params});
  }

  getItemsByVehicle(make,model,year){
    var params = {
      "make":make,
      "model":model,
      "year":year
    }
    const url = this.api + '/items/searchByVehicle';
    return axios.get(url,{params});
  }

  getPriceAndStock(make,model,year,loc){
    var params = {
      "make":make,
      "model":model,
      "year":year,
      "loc":loc

    }
    const url = this.api + '/items/getPriceAndStock';
    return axios.get(url,{params});
  }


  // Scheduling Api

  getAllJobTypes(){
    const url = this.api + '/jobs/types';
    return axios.get(url);
  }

  getAllTechnicians(id){
    const url = this.api + '/users/technician';
    const params = {id:id};
    return axios.get(url,{params});
  }

  getAllChannels(){
    const url = this.api + '/customer/channels';
    return axios.get(url);
  }
  
  getAllJobs() {
    const url = this.api + '/jobs/remaining'
    return axios.get(url);
  }

  addJob(request){
    const url = this.api + '/jobs/insert';
    return axios.post(url,request);
  }

  getJobHistoryById(id){
    const url = this.api + '/jobs/hist';
    return axios.post(url,{parmas});
  }

  getHistoryOfJob(id){
    var params = {
      "id":id
    }
    const url = this.api + '/jobs/jobhist';
    return axios.get(url,{params});
  }

  checkAvailability(email,to,from,date){
    var headers = {
      "user": email,
      "to": to,
      "from":from,
      "today":date
    }

    const url = this.api + '/jobs/availability';
    return axios.post(url, null, {"headers": headers});
  }

  searchJobsByWeek(monday){
    var params = {
      "monday":monday
    }
    const url = this.api + '/jobs/search';
    return axios.get(url,{params});
  }

  getJobById(id){
    var params = {
      "id":id
    }
    const url = this.api + '/jobs/job';
    return axios.get(url,{params});
  }

  getRescheduledJobs(){
    const url = this.api + '/jobs/rescheduled';
    return axios.get(url);
  }

  getJobHistory(filters){
    const url = this.api + '/jobs/history';
    return axios.post(url,filters);
  }

  rescheduleJob(request){
    const url = this.api + '/jobs/reschedule';
    return axios.post(url,request);
  }

  deleteJob(id){
    var params = {
      "id":id
    }
    const url = this.api + '/jobs/delete';
    return axios.delete(url,{params});
  }

}
